/**
 * CodeTerminals - Animated code snippet components
 * Disabled on mobile for performance
 */
function CodeTerminals() {
  const codeSnippets = [
    [
      'function scale() {',
      '  const innovation = true;',
      '  while (innovation) {',
      '    growth++;',
      '    impact++;',
      '  }',
      '  return success;',
      '}',
    ],
  ];

  return (
    <>
      <div className="code-terminal terminal-1">
        <div className="terminal-header">build.js</div>
        {codeSnippets[0].map((line, idx) => (
          <div key={idx} className="code-line" style={{ animationDelay: `${idx * 0.3}s` }}>
            <span className="line-number">{idx + 1}</span>
            <span className="code-content">{line}</span>
          </div>
        ))}
      </div>
    </>
  );
}

export default CodeTerminals;
